import { API_SITE, SESSION_KEY, apiBase, accessToken } from '../turnover/helpers.js';

export { API_SITE, SESSION_KEY, apiBase, accessToken };

export function formatCommissionMoney(value) {
  const n = Number(value || 0);
  const formatted = Math.abs(n).toFixed(2);
  return `${n < 0 ? '-' : ''}৳${formatted}`;
}

export function emptyAffiliateCommission() {
  return {
    customerType: 'general',
    commissionBalance: 0,
    commissionRate: 0,
    canTransfer: false,
    transferCooldownHours: 24,
    lastTransferAt: null,
    nextTransferAt: null,
    remainingSeconds: 0,
  };
}

export async function fetchReferrals() {
  const token = accessToken();
  const res = await fetch(`${apiBase()}/referrals`, {
    headers: {
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    cache: 'no-store',
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || json.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json.data || json;
}

export async function transferCommission(amount, idempotencyKey) {
  const token = accessToken();
  const res = await fetch(`${apiBase()}/referrals/commission-transfer`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    cache: 'no-store',
    body: JSON.stringify({ amount, idempotencyKey }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || json.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json.data || json;
}

export function formatCountdown(remainingSeconds) {
  const total = Math.max(0, Number(remainingSeconds) || 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  return `${hours}h ${String(minutes).padStart(2, '0')}m`;
}

export function bnCountdownLine(remainingSeconds) {
  const total = Math.max(0, Number(remainingSeconds) || 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  return `আপনি আবার ট্রান্সফার করতে পারবেন\n${hours} ঘণ্টা ${minutes} মিনিট পর`;
}
